
import React from "react";
import { FAQSection as CommonFAQSection } from "@/components/common/FAQ";

export interface FAQSectionProps {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

const FAQSection: React.FC<FAQSectionProps> = ({ faqs }) => {
  const formattedFaqs = faqs.map(faq => ({
    question: faq.question,
    answer: faq.answer
  }));

  return (
    <CommonFAQSection
      faqs={formattedFaqs}
      variant="simple"
    />
  );
};

export default FAQSection;
